import { createContext, useContext } from "react";
import { NavItemId, NavSectionId } from "./constants";
import { ResolvedNavSection } from "./nav-settings";

interface NavCustomizationValue {
  sections: ResolvedNavSection[];
  isCustomizing: boolean;
  isDefault: boolean;
  isSaved: boolean;
  startCustomizing: () => void;
  stopCustomizing: () => void;
  toggleHidden: (id: NavItemId) => void;
  moveItem: (sectionId: NavSectionId, from: number, to: number) => void;
  reset: () => void;
}

export const NavCustomizationContext =
  createContext<NavCustomizationValue | null>(null);

export const useNavCustomization = () => {
  const context = useContext(NavCustomizationContext);
  if (!context)
    throw new Error(
      "useNavCustomization must be used within NavCustomizationProvider"
    );

  return context;
};
